export default __webpack_public_path__ + "f67d77b1a43716249793133999ee7278.png";